/**
 * Whether a brain-proposed action should require explicit user approval before execute.
 * Read-style tools (get/list/query/convert timestamp, etc.) run automatically; mutating tools do not.
 */
export function previewProposedActionNeedsUserApproval(proposed, agent) {
  if (!proposed || typeof proposed !== "object") return true;
  const act = (agent?.actions || []).find((a) => a.action_id === proposed.action_id);
  const app = String(proposed.app || proposed.app_label || act?.app || act?.app_label || "").toLowerCase();
  const key = String(
    proposed.action_key || act?.action_key || act?.config?.action || act?.type || "",
  ).toLowerCase();
  // Preview runs Workload Code itself: bind, execute, and repair without an Approve click.
  if (app.includes("workload-code") || key === "runpython") return false;
  const label = String(proposed.label || act?.label || act?.action_label || "").toLowerCase();
  const text = `${key} ${label}`;

  const mutating =
    /\b(create|add|insert|update|modify|edit|delete|remove|destroy|send|submit|post|put|patch|upload|write|save|cancel|void|refund|charge|notify|publish|execute|dispatch|schedule|book|assign|close|open|approve|reject|archive|restore|duplicate|copy|move|transfer|pay|purchase|order|subscribe|unsubscribe|invite|revoke|grant)\b/.test(
      text,
    );
  if (mutating) return true;

  const readLike =
    /\b(get|list|search|query|find|fetch|read|retrieve|lookup|show|convert|format|parse|current|timestamp|detail|info|describe|validate|check|ping|health|_get|_list|_search|_find)\b/.test(
      text,
    ) || /^(get|list|search|find|fetch|read)/i.test(key);
  if (readLike) return false;

  return true;
}

export function partitionProposalsByApproval(proposals, agent) {
  const needsApproval = [];
  const readOnlyIndices = [];
  (proposals || []).forEach((p, i) => {
    if (previewProposedActionNeedsUserApproval(p, agent)) needsApproval.push(i);
    else readOnlyIndices.push(i);
  });
  return { needsApproval, readOnlyIndices };
}
